export default __webpack_public_path__ + "static/media/main-login.90fb6b8b.svg";